import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Text } from "@mantine/core";
import { EPaymentMethod } from "../models/EPaymentMethod";
import PaymentMethod from "./paymentMethod/PaymentMethod";

interface ICreditCardProps {
  isChosen: boolean;
  onChoose: (method: EPaymentMethod) => void;
}

const CreditCardPaymentMethod: React.FC<ICreditCardProps> = ({
  isChosen,
  onChoose,
}) => {
  const { t } = useAppTranslation("pages.order.basket.paymentMethod");
  return (
    <PaymentMethod
      icon={
        <Group>
          <Icon.MasterCard size={30} />
          <Icon.Visa size={30} />
        </Group>
      }
      isChosen={isChosen}
      onChoose={() => onChoose(EPaymentMethod.CREDIT_CARD)}
    >
      <Text className="font-inter text-primary-white">{t("creditCard")}</Text>
    </PaymentMethod>
  );
};

export default CreditCardPaymentMethod;
